import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const unpackBundleEndpoint = {
    authentication: authenticationTypes.authenticated,
    authenticationRole: userGroups.brandUser,
    endpointType: otherEndpointType,
    payloadSchema: {
        type: 'object',
        properties: {
            bundleId: { type: 'string' },
            amount: { type: 'integer', minimum: 1 },
        },
        required: ['bundleId', 'amount'],
    },
};
